interface PropertyDepreciation {
  amount: number;
  rate: number;
  years: number;
}

interface PropertyDepreciationConstructor {
  new (): PropertyDepreciation;
}

function PropertyDepreciation(this: PropertyDepreciation) {
  this.amount = Number(0);
  this.rate = Number(0.025);
  this.years = Number(40);
}

export default PropertyDepreciation as unknown as PropertyDepreciationConstructor;
